import { createIcon } from '@chakra-ui/icons';

export const ShortAnswer = createIcon({
  displayName: 'ShortAnswer',
  viewBox: '0 0 24 24',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_454_5091)">
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
          fill="#FDE9C8"
        />
        <g clipPath="url(#clip1_454_5091)">
          <path
            d="M6.87488 14.4997C6.93563 14.4997 6.99638 14.4922 7.05638 14.4772L10.0564 13.7272C10.1884 13.6942 10.3091 13.6259 10.4051 13.5299L14.9051 9.02995C15.1984 8.7367 15.1984 8.2627 14.9051 7.96945L12.6551 5.71945C12.3619 5.4262 11.8879 5.4262 11.5946 5.71945L7.09463 10.2194C6.99863 10.3154 6.93038 10.4362 6.89738 10.5674L6.14738 13.5674C6.08288 13.8232 6.15863 14.0932 6.34463 14.2799C6.48638 14.4225 6.67838 14.4997 6.87488 14.4997ZM8.30213 11.1329L12.1249 7.3102L13.3144 8.4997L9.49088 12.3224L7.90538 12.7184L8.30213 11.1329Z"
            fill="#977334"
          />
          <path
            d="M17.375 16H6.875C6.46025 16 6.125 16.336 6.125 16.75C6.125 17.164 6.46025 17.5 6.875 17.5H17.375C17.7898 17.5 18.125 17.164 18.125 16.75C18.125 16.336 17.7898 16 17.375 16Z"
            fill="#977334"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_454_5091">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_454_5091">
          <rect width="12" height="12" fill="white" transform="translate(6.125 5.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
